function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPromotionEarlyBirdFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.91 12.167l.383-2.325c.042-.254.07-.511.085-.769l-8.211 3.41v-4.65a3.832 3.832 0 00-5.75-3.32A3.834 3.834 0 007.5 7.834v4.082a10.251 10.251 0 006.833 9.651l.913.323 1.055.16c.48.073.964.112 1.449.117.485-.005.97-.044 1.45-.117l1.055-.16.912-.323a10.251 10.251 0 006.83-9.399H22.91zm7.09-.25a12.25 12.25 0 01-8.167 11.535V30H19.5v-5.974a12.375 12.375 0 01-1.75.14 12.275 12.275 0 01-1.75-.14V30h-2.333v-6.548A12.248 12.248 0 015.5 11.917v-1.75H2V7.833h3.5a5.833 5.833 0 0111.667 0v1.654l6.553-2.721a1.168 1.168 0 011.613.875 9.278 9.278 0 01-.067 2.526h3.567A1.166 1.166 0 0130 11.333v.584z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 8.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: props.color
  }));
}

export default SvgIconPromotionEarlyBirdFilled;